import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import GridModal from '../../Components/Modal_Grid';
import Commons from '../../Services/Common/Common';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function MM10030(props) {
    React.useEffect(() => {
        document.title = '생산현황';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>생산현황</strong>" +
            '</h1>';
    }, []);
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    //출력 팝업창
    const [modalToggle, setModalToggle] = React.useState(false);
    const AuthGroupSettingClicked = (_data) => {
        if (
            props.selectedRowData1.length == 0 ||
            props.selectedRowData1[0].endProcess == '종료' ||
            props.selectedRowData1[0].endProcess == '시작'
        ) {
            props.GetPrintStockData();

            return false;
        } else {
            props.GetPrintStockData();

            setModalToggle(true);
        }
    };
    const lotColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 50,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            valueGetter: 'node.rowIndex + 1',
        },
        //LOT No
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        // //품목코드
        // {
        //   field: "itemCd",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        // },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    ///////////
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    // 상단 그리드
    const columnDefs = [
        {
            field: 'woNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WoNo' && f.lanType === 'COL')[0].lanName
                    : '', //작업지시번호
            minWidth: 130,
        },
        {
            field: 'workDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkDt' && f.lanType === 'COL')[0].lanName
                    : '', //작업지시일자
            minWidth: 130,
            editable: true,
        },
        {
            field: 'stusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkStatus' && f.lanType === 'COL')[0].lanName
                    : '', //작업상태
            cellRenderer: Commons.CustomHeaderRenderer,
        },

        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품명
            minWidth: 300,
        },
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격1
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'soDueNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueNo' && f.lanType === 'COL')[0].lanName
                    : '', //납기번호
            minWidth: 100,
        },
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '', //납기일
            minWidth: 100,
        },

        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '', //주문수량
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockQty' && f.lanType === 'COL')[0].lanName
                    : '', //재고수량
            editable: true,
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '', //주문번호
        },
    ];
    //하단 그리드 컬럼
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 80,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'processNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessNm' && f.lanType === 'COL')[0].lanName
                    : '', //공정명
        },
        {
            field: 'workUser',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkUser' && f.lanType === 'COL')[0].lanName
                    : '', //작업자
        },
        {
            field: 'machineNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_MachineNm' && f.lanType === 'COL')[0].lanName
                    : '', //설비명
        },
        {
            field: 'seqQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SeqQty' && f.lanType === 'COL')[0].lanName
                    : '',
            hide: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'wkStDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WkStDt' && f.lanType === 'COL')[0].lanName
                    : '', //시작일
            // valueFormatter: (params) => {
            //   var formatted = params.value
            //     ? params.value
            //         .toString()
            //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
            //     : "";
            //   return formatted;
            // },
        },
        {
            field: 'wkEdDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WkEdDt' && f.lanType === 'COL')[0].lanName
                    : '', //종료일
            // valueFormatter: (params) => {
            //   var formatted = params.value
            //     ? params.value
            //         .toString()
            //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
            //     : "";
            //   return formatted;
            // },
        },
        {
            field: 'endProcess',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_EndProcess' && f.lanType === 'COL')[0].lanName
                    : '', //생산여부
            minWidth: 100,
            cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
                if (params.data) {
                    return (
                        <div
                            style={{
                                color:
                                    params.data.endProcess === '중간출력'
                                        ? 'red'
                                        : params.data.endProcess === '최종/출력'
                                        ? 'blue'
                                        : '',
                            }}
                        >
                            {params.data.endProcess}
                        </div>
                    );
                }
            },
        },
        {
            field: 'wkDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WkDt' && f.lanType === 'COL')[0].lanName
                    : '', //작업시간
            cellStyle: { textAlign: 'right' },
            // valueFormatter: (e) => {
            //   var formatted = !e.data
            //     ? ""
            //     : e.data.wkEdDt === ""
            //     ? ""
            //     : Commons.calculateDateTimeDifference(e.data.wkStDt, e.data.wkEdDt);
            //   return formatted;
            // },
            aggFunc: 'sum',
            aggFunc: (params) => {
                // 결과를 저장할 변수 초기화
                var totalHours = 0;
                var totalMinutes = 0;

                // 배열을 순회하며 값 더하기
                params.values.forEach(function (element) {
                    // 요소에서 인덱스를 추출
                    var indices = element.match(/\[(\d+):(\d+)\]/);
                    var hours = parseInt(indices[1]);
                    var minutes = parseInt(indices[2]);

                    // 더한 값들에 현재 요소의 시간과 분을 더함
                    totalHours += hours;
                    totalMinutes += minutes;
                });
                // 분이 60분을 넘어갈 경우 시간을 조정
                if (totalMinutes >= 60) {
                    var additionalHours = Math.floor(totalMinutes / 60);
                    totalHours += additionalHours;
                    totalMinutes %= 60;
                }
                // 결과 출력
                var result = '[' + totalHours + ':' + totalMinutes + ']';
                return result;
            },
        },
        {
            field: 'seqQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SeqQty' && f.lanType === 'COL')[0].lanName
                    : '', //양품수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
            // cellRenderer: (params) => {
            //   if (params.data) {
            //     return (
            //       <div
            //         style={{
            //           color:
            //             params.data.endProcess === "출력"
            //               ? "red"
            //               : params.data.endProcess === "최종"
            //               ? "blue"
            //               : "",
            //         }}
            //       >
            //         {params.data.seqQty}
            //       </div>
            //     );
            //   }
            // },
        },
        {
            field: 'seqFailQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FailQty' && f.lanType === 'COL')[0].lanName
                    : '', //불량수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'seqQtyRate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_QtyRate' && f.lanType === 'COL')[0].lanName
                    : '', //양품률
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '%'
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'seqFailQtyRate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FailQtyRate' && f.lanType === 'COL')[0].lanName
                    : '', //불량률
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '%'
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
    ];

    const onCellClicked = (e) => {
        const selected = e.data;
        props.SearchWorkLogic(selected.woNo, selected.itemCd);
    };

    return (
        <div>
            <div>
                <div style={{ height: '50%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.startDate}
                                onChange={(e) => {
                                    props.setStartDate(e);
                                }}
                            />{' '}
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.endDate}
                                onChange={(e) => {
                                    props.setEndDate(e);
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <BasicButton
                                name={
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_WorkCancle' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '' //생산취소
                                }
                                onClick={() => props.WorkCancleConfirm()}
                            />
                            {/* 상단 그리드 버튼 */}
                            <AuthGroupButton
                                pageName="MM10030"
                                target="G01"
                                refreshNone="none"
                                refreshFunc={() => {
                                    props.Init();
                                }}
                                selectFunc={() => {
                                    props.SearchLogic();
                                }}
                                saveFunc={() => props.SaveConfirm()}
                                deleteFunc={() => props.DeleteConfirm()}
                                onCellClicked={onCellClicked}
                            />
                        </div>
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '335px' }}>
                        {/* 상당 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            frameworkComponents={{
                                customHeaderRenderer: Commons.CustomHeaderRenderer,
                            }}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
                            }
                            onCellClicked={onCellClicked}
                        />
                    </div>
                </div>

                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '370px' }}>
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'end',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <BasicButton
                                name={
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_RePrint' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '' //재출력
                                }
                                // onClick={() => props.BarCodePrintConfirm()}
                                onClick={(e) => AuthGroupSettingClicked(e)}
                            />
                            {/* 하단 그리드 버튼 */}
                            <AuthGroupButton
                                pageName="MM10030"
                                target="G02"
                                refreshNone="none"
                                refreshFunc={() => {
                                    props.Init();
                                }}
                                addFunc={() =>
                                    // gridRef.current.api.setRowData([{}, ...props.rowData])
                                    props.setModalToggle(true)
                                }
                                saveFunc={() => props.SaveConfirm()}
                                deleteFunc={() => props.DeleteConfirm()}
                            />
                        </div>
                    </Card>
                    {/* 하단 그리드  */}
                    <AgGridReact
                        ref={gridRef1}
                        animateRows={true}
                        groupIncludeTotalFooter={true}
                        columnDefs={columnDefs1}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        rowData={props.rowData1}
                        rowSelection="single"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)}
                        // onCellClicked={onCellClicked}
                    />
                </div>
                {/* 재출력 */}
                {modalToggle && (
                    <GridModal
                        conditions={[]}
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM')[0]
                                      .lanName
                                : ''
                        }
                        onClose={() => setModalToggle(false)}
                        gridColumn={lotColumnDef}
                        gridRowData={props.stockData}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_In' && f.lanType === 'BTN')[0].lanName
                                : '' //출력
                        }
                        gridOnClick={(e) => {
                            let data = [];
                            for (let i = 0; i < e.length; i++) {
                                data.push({
                                    itemCd: e[i].itemNm,
                                    lotNo: e[i].lotNo,
                                    stockQty: e[i].stockQty,
                                    whNm: e[i].whNm,
                                });
                            }
                            props.setSelectedModalData(data);
                        }}
                        execLogic={(e) => {
                            props.BarCodePrintConfirm();
                        }}
                    />
                )}
            </div>
        </div>
    );
}

export default MM10030;
